module.exports = __webpack_public_path__ + "static/img/chuzhongwuli.ac380480.jpg";